import { Box, Group, Stack, Text, TextInput } from "@mantine/core";
import React from "react";
import { IRapportOppdrag } from "./types";

const LABEL_WIDTH = 140;

const ReportProjectInfo: React.FC<{
  infoOmUppdraget: IRapportOppdrag;
  setInfOmOppdrag: (value: string, key: string) => void;
}> = ({ infoOmUppdraget, setInfOmOppdrag }) => {
  return (
    <Box w="50%">
      <Text fw={600} size="lg" mb="sm">
        Info om oppdraget
      </Text>
      <Stack gap="sm" align="left">
        <Group>
          <Text w={LABEL_WIDTH} size="sm">
            Oppdragsgiver:
          </Text>
          <TextInput
            size="sm"
            value={infoOmUppdraget.oppdragsgiver}
            onChange={(e) => setInfOmOppdrag(e.currentTarget.value, "oppdragsgiver")}
            w={300}
          />
        </Group>
        <Group>
          <Text w={LABEL_WIDTH} size="sm">
            Oppdragsnavn:
          </Text>
          <TextInput
            size="sm"
            value={infoOmUppdraget.oppdragsnavn}
            onChange={(e) => setInfOmOppdrag(e.currentTarget.value, "oppdragsnavn")}
            w={300}
          />
        </Group>
        <Group>
          <Text w={LABEL_WIDTH} size="sm">
            Oppdragsnummer:
          </Text>
          <TextInput
            size="sm"
            value={infoOmUppdraget.oppdragsnummer}
            onChange={(e) => setInfOmOppdrag(e.currentTarget.value, "oppdragsnummer")}
            w={300}
          />
        </Group>
      </Stack>
    </Box>
  );
};

export default ReportProjectInfo;
